import { render, staticRenderFns } from "./NavigationBlack.vue?vue&type=template&id=6878116c&scoped=true"
var script = {}
import style0 from "./NavigationBlack.vue?vue&type=style&index=0&id=6878116c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878116c",
  null
  
)

export default component.exports